import { resolveUploadUrl } from '../config/api';

// Use require.context to load all partner logos
const partnerLogosContext = require.context('../assets/logos/partners', false, /\.(png|jpg|jpeg|svg|webp)$/);

// Create a map of filename to imported logo
const partnerLogosMap = {};
partnerLogosContext.keys().forEach((item) => {
  const fileName = item.replace('./', '');
  partnerLogosMap[fileName] = partnerLogosContext(item);
});

// Helper function to get partner logo
export const getPartnerLogo = (imageName) => {
  // Try exact match first
  if (partnerLogosMap[imageName]) {
    return partnerLogosMap[imageName];
  }
  
  // Try case-insensitive match
  const matchedKey = Object.keys(partnerLogosMap).find(
    key => key.toLowerCase() === imageName.toLowerCase()
  );
  
  if (matchedKey) {
    return partnerLogosMap[matchedKey];
  }
  
  console.warn(`Partner logo not found: ${imageName}`);
  return null;
};

/**
 * Logo URL from API (admin): absolute http(s), /uploads/... path, or bundled filename.
 */
export function resolvePartnerLogoUrl(logoUrl) {
  if (!logoUrl || typeof logoUrl !== 'string') return null;
  const t = logoUrl.trim();
  if (!t) return null;
  if (/^https?:\/\//i.test(t)) return t;
  const path = t.startsWith('/') ? t : `/${t}`;
  if (path.startsWith('/uploads')) {
    return resolveUploadUrl(path);
  }
  const fileName = path.replace(/^\//, '');
  return getPartnerLogo(fileName);
}
